export function faTaToggle(group: string, callback: Function) {
    const container = document.querySelector(`div.group[data-name="${group}"] h3`);
    const faTaToggle = document.getElementById('fa-ta-toggle');
    if (faTaToggle || !container) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'btn-group btn-group-sm pt-3 px-3 d-block text-center';
    wrapper.id = 'fa-ta-toggle';

    const faBtn = document.createElement('button');
    const taBtn = document.createElement('button');

    faBtn.textContent = 'FA';
    taBtn.textContent = 'TA';

    taBtn.className = 'btn btn-fata active';
    faBtn.className = 'btn btn-fata';

    // Toggle logic
    faBtn.onclick = () => {
      faBtn.classList.add('active');
      taBtn.classList.remove('active');
      callback('faQusAvg')
      // trigger FA-specific logic here
    };

    taBtn.onclick = () => {
      taBtn.classList.add('active');
      faBtn.classList.remove('active');
      callback('taQusAvg')
      // trigger TA-specific logic here
    };

    wrapper.appendChild(faBtn);
    wrapper.appendChild(taBtn);
    container?.after(wrapper);
}


const richTextAttrs = ['richText', 'richTextBody', 'richTextHeader'];


export function updateTextFromAttr(view: any) {
  richTextAttrs.forEach((attr) => {
      const editable = view.el.querySelector(`[joint-selector="${attr}"]`);
      if (editable) {
          editable.innerHTML = view.model.attr(`${attr}/content`) || '';
      }
    }
  );
}

export function updateAttrFromText(view: any) {
  richTextAttrs.forEach((attr) => {
      const editable = view.el.querySelector(`[joint-selector="${attr}"]`);
      if (editable) {
          view.model.attr(`${attr}/content`, editable.innerHTML);
      }
    }
  );
}


export function observeAttributes(targetElement: Element, callback: Function) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        const attrName = mutation.attributeName as string;
        const newValue = targetElement.getAttribute(attrName);
        callback(attrName, newValue);
      }
    }
  });

  observer.observe(targetElement, { attributes: true });
  return observer; // so you can disconnect later if needed
}
